/**
 * @description
 * As a music editor, I want download options in a dialog, so that I can choose mixes, stems, and format before downloading.
 */
import { useEffect } from 'react'

import DownloadOptions from './DownloadOptions/DownloadOptions'
import {
	DownloadProvider,
	useDownloadContext,
} from './DownloadOptionsModal.context'
import { DownloadOptionsModalProps } from './DownloadOptionsModal.types'

const getCommandForAttributeSelector = (modalId: string): string => {
	const escapedModalId = modalId.replace(/\\/g, '\\\\').replace(/"/g, '\\"')

	return `[commandfor="${escapedModalId}"][command="show-modal"]`
}

const LoadOptionsWhenOpenCommandIsUsed = (): null => {
	const { loadDownloadOptions, modalId } = useDownloadContext()

	useEffect(() => {
		const openButtonSelector = getCommandForAttributeSelector(modalId)

		const handleOpenClick = (event: MouseEvent): void => {
			const target = event.target

			if (!(target instanceof Element)) {
				return
			}

			const openButton = target.closest(openButtonSelector)

			if (!openButton) {
				return
			}

			void loadDownloadOptions()
		}

		document.addEventListener('click', handleOpenClick, true)

		return () => {
			document.removeEventListener('click', handleOpenClick, true)
		}
	}, [loadDownloadOptions, modalId])

	return null
}

const DownloadOptionsModal = ({
	isSelection,
	modalId,
	trackSource,
	tracks,
	zipFileName,
}: DownloadOptionsModalProps): JSX.Element => {
	return (
		<DownloadProvider
			initialTracks={tracks}
			isSelection={isSelection}
			modalId={modalId}
			trackSource={trackSource}
			zipFileName={zipFileName}
		>
			<DownloadOptions />
			<LoadOptionsWhenOpenCommandIsUsed />
		</DownloadProvider>
	)
}

export default DownloadOptionsModal
